import { createAction, handleActions } from 'redux-actions';
import update from 'immutability-helper';
import _get from 'lodash/get';

export const open = createAction('@@modal/open');
export const hide = createAction('@@modal/hide');

export const statusSelector = state => _get(state, 'modal.opened', false);

const initialState = {
  opened: false,
  modalType: null,
  modalProps: {},
};

export const reducer = handleActions(
  {
    [open]: {
      next: (state, { payload }) => {
        return update(state, {
          opened: { $set: true },
          modalType: { $set: payload.modalType },
          modalProps: { $set: payload.modalProps },
        });
      },
    },

    [hide]: (state, { payload }) => {
      return update(state, {
        opened: { $set: false },
        modalType: { $set: null },
        modalProps: { $set: null },
      });
    },
  },
  initialState
);

export default reducer;
